/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SavedCommoditiesCommitRow
 */
export interface SavedCommoditiesCommitRow {
  /**
   *
   * @type {number}
   * @memberof SavedCommoditiesCommitRow
   */
  rowNumber: number;
  /**
   *
   * @type {string}
   * @memberof SavedCommoditiesCommitRow
   */
  skuIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedCommoditiesCommitRow
   */
  outcome: string;
  /**
   *
   * @type {Array<string>}
   * @memberof SavedCommoditiesCommitRow
   */
  errors: Array<string>;
}

/**
 * Check if a given object implements the SavedCommoditiesCommitRow interface.
 */
export function instanceOfSavedCommoditiesCommitRow(
  value: object,
): value is SavedCommoditiesCommitRow {
  if (!("rowNumber" in value) || value["rowNumber"] === undefined) return false;
  if (!("outcome" in value) || value["outcome"] === undefined) return false;
  if (!("errors" in value) || value["errors"] === undefined) return false;
  return true;
}

export function SavedCommoditiesCommitRowFromJSON(
  json: any,
): SavedCommoditiesCommitRow {
  return SavedCommoditiesCommitRowFromJSONTyped(json, false);
}

export function SavedCommoditiesCommitRowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SavedCommoditiesCommitRow {
  if (json == null) {
    return json;
  }
  return {
    rowNumber: json["rowNumber"],
    skuIdentifier:
      json["skuIdentifier"] == null ? undefined : json["skuIdentifier"],
    outcome: json["outcome"],
    errors: json["errors"],
  };
}

export function SavedCommoditiesCommitRowToJSON(
  json: any,
): SavedCommoditiesCommitRow {
  return SavedCommoditiesCommitRowToJSONTyped(json, false);
}

export function SavedCommoditiesCommitRowToJSONTyped(
  value?: SavedCommoditiesCommitRow | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    rowNumber: value["rowNumber"],
    skuIdentifier: value["skuIdentifier"],
    outcome: value["outcome"],
    errors: value["errors"],
  };
}
